<template>
	<div class="popup_inner score-popup" :class="{'ajax_processed': isLoading}">
		<div class="popup_head">Поделитесь мнением</div>
		<div class="popup_cont popup_cont--info">
			<div class="rate-block rate-block--wide">
				<fieldset class="rate">
					<input v-model="formData.score" type="radio" id="asf-rating10" value="5">
					<label for="asf-rating10" title="5"></label>
					<input v-model="formData.score" type="radio" id="asf-rating9" value="4.5">
					<label for="asf-rating9" title="4.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="asf-rating8" value="4">
					<label for="asf-rating8" title="4"></label>
					<input v-model="formData.score" type="radio" id="asf-rating7" value="3.5">
					<label for="asf-rating7" title="3.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="asf-rating6" value="3">
					<label for="asf-rating6" title="3"></label>
					<input v-model="formData.score" type="radio" id="asf-rating5" value="2.5">
					<label for="asf-rating5" title="2.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="asf-rating4" value="2">
					<label for="asf-rating4" title="2"></label>
					<input v-model="formData.score" type="radio" id="asf-rating3" value="1.5">
					<label for="asf-rating3" title="1.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="asf-rating2" value="1">
					<label for="asf-rating2" title="1"></label>
					<input v-model="formData.score" type="radio" id="asf-rating1" value="0.5">
					<label for="asf-rating1" title="0.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="asf-rating0" value="0">
					<label for="asf-rating0" title="0"></label>
				</fieldset>
				<div class="rate-block__actions">
					<button class="btn" :disabled="!formData.score" @click="onSendScore">Отправить оценку</button>
					<button class="btn btn_red" :disabled="!formData.score" @click="openFullReviewPopup">Написать отзыв</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { isRecaptchaError } from '../../utils/errors.js';
export default {
	name: 'AddScoreForm',
	setup() {
		return {
			isRecaptchaError
		}
	},
	data() {
		return {
			formData: {
				score: 0,
			},
            isLoading: false,
		}
	},
	computed: {
	...mapGetters({
			getYandexSiteKey: 'getYandexSiteKey',
			getReviewProductId: 'getReviewProductId',
		})
	},
	watch: {
		'formData.score'(value) {
			this.setReviewPreselectedScore(value);
		}
	},
	methods : {
		async onSendScore() {
            this.isLoading = true;
            this.executeYandexCaptcha(this.sendScore);
		},
		async sendScore() {
            const token = window.smartCaptcha && window.smartCaptcha.getResponse() || '';
            const data = {
				productId: this.getReviewProductId,
				score: this.formData.score,
			};
			const response = await this.requestAddReview({data, yandexCaptchaToken: token});
			if (response.data) {
				window.openCompactModal('add-score-success');
				this.resetForm();
			}
            this.isLoading = false;
		},
		openFullReviewPopup() {
			window.$.fancybox({ href: '#add-review-popup'});
		},
		resetForm() {
			this.formData.score = 0;
		},
		...mapMutations({
			setReviewPreselectedScore: 'setReviewPreselectedScore',
		}),
		...mapActions({
			requestAddReview: 'requestAddReview',
            executeYandexCaptcha: 'executeYandexCaptcha',
		}),
	},
}
</script>
